import React from "react";
import axios from 'axios';
import './Mobileheader.css';
import CloseIcon from '@mui/icons-material/Close';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import { Link } from 'react-router-dom';
class Mobilemenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sub : []
            
        }
        
    };
    componentDidMount(){
        axios.get(encodeURI(process.env.REACT_APP_API_URL +'api/method/ecom.api.main_groups'), {
            headers : { 'content-type': 'application/json'}
           
        })
        .then(response=>{
            this.setState({sub:response.data['message']})
            
        })
       
        }
    render() {
        return<ul className="user-nav">
                <ProSidebar>
                <label htmlFor="box" className="btn-area float-right close-icn-align mt-3"><CloseIcon className="float-right"/></label>
                <a href="/home" className="my-menu-itm"><MenuItem >Home</MenuItem></a>
                    <Menu iconShape="square">
                        {this.state.sub.map((itm,k)=>{
                                    return(
                                        <MenuItem key={k}><a  href={'/'+itm.route}>{itm.name}</a></MenuItem>
                                    
                          )
                        })}           
                       
                    </Menu>
                    <a href="/about-us" className="my-menu-itm mb-3"><MenuItem >About us</MenuItem></a>
                        <a href="/contact-us" className="my-menu-itm"><MenuItem >Contact us</MenuItem></a>
                </ProSidebar>;
                
            </ul>
    }
}

export default Mobilemenu;